module.exports = __webpack_public_path__ + "media/images/swifticons/weather-partly-cloudy-678aaca1860e6e768e02f16c3152dd32.svg";